import { render, staticRenderFns } from "./account-status.component.vue?vue&type=template&id=5b5e45c8&"
import script from "./account-status.component.vue?vue&type=script&lang=ts&"
export * from "./account-status.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports